import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function IndeterminateIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    fill: "none",
    viewBox: "0 0 12 12",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 7H1V5h10v2z",
      clipRule: "evenodd"
    })
  });
}
export default IndeterminateIcon;